/**
 * Operations that handle their own failures quietly (background work the user
 * must not be interrupted by, e.g. the eNPS survey) opt out of error toasts by
 * passing this in their operation context. Kept dependency-free so importing
 * it never pulls in the client, the exchanges or the app's i18n instance.
 */
export const SILENT_ERRORS_CONTEXT = { silentErrors: true } as const;
